// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout-module--container--3zlEr","nav":"PageLayout-module--nav--33ZO_","main":"PageLayout-module--main--I3CBu","fade":"PageLayout-module--fade--alqI7"};